export default "__VITE_ASSET__CkwDWNXk__";